import React from 'react'

export interface LoaderProps {
  className?: string
}

export function Loader({ className = '' }: LoaderProps) {
  const isDarkMode = className.includes('dark-mode')
  
  return (
    <div 
      className={`w-[72px] h-[72px] p-0 flex items-center justify-center ${className}`}
      role="status" 
      aria-label="Loading"
    >
      <div className="relative">
        <svg 
          width="72" 
          height="72" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Base logo shapes */}
          <path 
            d="M12 18C12 21.3137 9.31371 24 6 24C2.68629 24 0 21.3137 0 18C0 14.6863 2.68629 12 6 12C9.31371 12 12 14.6863 12 18Z" 
            fill={isDarkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'}
          />
          <path 
            d="M6 3C6 1.34315 7.34315 0 9 0C10.6569 0 12 1.34315 12 3V12H6V3Z" 
            fill={isDarkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'}
          />
          <path 
            d="M12 3C12 1.34315 13.3431 0 15 0C16.6569 0 18 1.34315 18 3V12H12V3Z" 
            fill={isDarkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'}
          />
          <path 
            d="M12 12H24V18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18V12Z" 
            fill={isDarkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.08)'}
          />
        </svg>
        
        {/* Clean shimmer overlay */}
        <div 
          className="absolute inset-0"
          style={{
            WebkitMask: `
              url("data:image/svg+xml;base64,${btoa(`
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 18C12 21.3137 9.31371 24 6 24C2.68629 24 0 21.3137 0 18C0 14.6863 2.68629 12 6 12C9.31371 12 12 14.6863 12 18Z"/>
                  <path d="M6 3C6 1.34315 7.34315 0 9 0C10.6569 0 12 1.34315 12 3V12H6V3Z"/>
                  <path d="M12 3C12 1.34315 13.3431 0 15 0C16.6569 0 18 1.34315 18 3V12H12V3Z"/>
                  <path d="M12 12H24V18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18V12Z"/>
                </svg>
              `)}")`,
            mask: `
              url("data:image/svg+xml;base64,${btoa(`
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 18C12 21.3137 9.31371 24 6 24C2.68629 24 0 21.3137 0 18C0 14.6863 2.68629 12 6 12C9.31371 12 12 14.6863 12 18Z"/>
                  <path d="M6 3C6 1.34315 7.34315 0 9 0C10.6569 0 12 1.34315 12 3V12H6V3Z"/>
                  <path d="M12 3C12 1.34315 13.3431 0 15 0C16.6569 0 18 1.34315 18 3V12H12V3Z"/>
                  <path d="M12 12H24V18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18V12Z"/>
                </svg>
              `)}\")`
          }}
        >
          <div 
            className="w-full h-full"
            style={{
              background: isDarkMode ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.5)',
              transform: 'translateX(-100%)',
              animation: 'shimmer-sweep 2s ease-in-out infinite'
            }}
          />
        </div>
        
        <style dangerouslySetInnerHTML={{
          __html: `
            @keyframes shimmer-sweep {
              0% {
                transform: translateX(-100%) skewX(-15deg);
                opacity: 0;
              }
              20% {
                opacity: 1;
              }
              80% {
                opacity: 1;
              }
              100% {
                transform: translateX(100%) skewX(-15deg);
                opacity: 0;
              }
            }
            
            @-webkit-keyframes shimmer-sweep {
              0% {
                transform: translateX(-100%) skewX(-15deg);
                opacity: 0;
              }
              20% {
                opacity: 1;
              }
              80% {
                opacity: 1;
              }
              100% {
                transform: translateX(100%) skewX(-15deg);
                opacity: 0;
              }
            }
          `
        }} />
      </div>
    </div>
  )
}